import { render } from "./MachinesCreate.vue?vue&type=template&id=0253fac3&scoped=true"
import script from "./MachinesCreate.vue?vue&type=script&lang=js"
export * from "./MachinesCreate.vue?vue&type=script&lang=js"

import "./MachinesCreate.vue?vue&type=style&index=0&id=0253fac3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0253fac3"]])

export default __exports__